module.exports = __webpack_public_path__ + "static/media/1.84e5a2cd.jpg";